import React, { ReactElement } from 'react';

import cn from 'classnames';

import styles from './Select.module.css';
import { useOrionUID } from '../../helpers/orionUID';
import { Description } from '../description/Description';
import { Icon, Icons } from '../icon/Icon';
import { Label } from '../label/Label';
import { Message } from '../message/Message';

type SelectProps = {
  /** @deprecated */
  label?: string | ReactElement | ReactElement[];
  /** @deprecated */
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  /** @deprecated */
  description?: string;
  /** @deprecated */
  descriptionProps?: React.HTMLAttributes<HTMLSpanElement>;
  /** @deprecated */
  error?: string;
  /** @deprecated */
  success?: string;
  /** @deprecated */
  icon?: (typeof Icons)[number];
  placeholder?: string;
  /** @deprecated */
  wrapperClassName?: string;
} & React.InputHTMLAttributes<HTMLSelectElement>;

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      className,
      wrapperClassName,
      icon,
      placeholder,
      disabled,
      label,
      labelProps,
      description,
      descriptionProps,
      error,
      success,
      children,
      ...selectProps
    },
    ref,
  ) => {
    if (wrapperClassName) {
      console.warn('wrapperClassName is deprecated');
    }
    if (icon) {
      console.warn('icon is deprecated');
    }
    if (label) {
      console.warn('label is deprecated');
    }
    if (labelProps) {
      console.warn('labelProps is deprecated');
    }
    if (description) {
      console.warn('description is deprecated');
    }
    if (descriptionProps) {
      console.warn('descriptionProps is deprecated');
    }
    if (error) {
      console.warn('error is deprecated');
    }
    if (success) {
      console.warn('success is deprecated');
    }

    const orionUID = useOrionUID();
    const placeholderProps =
      selectProps.value === undefined
        ? {
            defaultValue: '',
          }
        : {};

    return (
      <div className={cn(styles.formElementWrapper, wrapperClassName)}>
        {label && (
          <Label htmlFor={selectProps.id || orionUID} {...labelProps}>
            {label}
          </Label>
        )}
        {description && (
          <Description
            className={styles.description}
            description={description}
            id={`${selectProps.id || orionUID}_desc`}
            {...descriptionProps}
          />
        )}
        <div
          className={cn(styles.selectWrapper, className, {
            [styles.disabled]: disabled,
            [styles.iconPadding]: !!icon,
            [styles.topMargin]: !!label || !!description,
          })}
        >
          {icon && <Icon icon={icon} />}
          <select
            ref={ref}
            disabled={disabled}
            aria-describedby={`${selectProps.id || orionUID}_desc`}
            id={orionUID}
            {...placeholderProps}
            {...selectProps}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {children}
          </select>
        </div>
        <div className={styles.status}>
          {error && <Message message={error} type="error" />}
          {success && <Message message={success} type="success" />}
        </div>
      </div>
    );
  },
);

Select.displayName = 'Select';
